
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA en Normandie dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads en Normandie certifiée Google Partner, conçoit des campagnes sur-mesure pour accroître votre visibilité Google et générer plus de prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads en Normandie dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads en Normandie certifiée Google Partner, conçoit des campagnes sur-mesure pour accroître votre visibilité Google et générer plus de prospects qualifiés.",
        },
      ],
    };
  },
};
